module.exports = __webpack_public_path__ + "static/media/ng.992459a3.svg";